
import React, { useState } from "react";

export default function App() {
  const [menu, setMenu] = useState(false);

  const products = [
    {name:"Industrial Tools", img:"https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc"},
    {name:"Hardware Materials", img:"https://images.unsplash.com/photo-1591238372408-8b98667c0460?q=80&w=2787&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"},
    {name:"Construction Supplies", img:"https://images.unsplash.com/photo-1503387762-592deb58ef4e"},
    {name:"Electrical Items", img:"https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"},
    {name:"Power Tools", img:"https://images.unsplash.com/photo-1518779578993-ec3579fee39f"},
    {name:"Safety Equipment", img:"https://images.unsplash.com/photo-1662309376159-b95fb193d96b?q=80&w=2787&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"}
  ];

  const reviews = [
    {text:"Shyam Traders always delivers top quality materials on time. Their pricing is very competitive.", name:"Rajesh Kumar"},
    {text:"We have been purchasing industrial supplies from them for years. Very reliable supplier.", name:"Amit Sharma"},
    {text:"Excellent customer service and genuine products. Highly recommended.", name:"Sunita Verma"},
    {text:"Our construction projects depend on suppliers like Shyam Traders. Great experience.", name:"Deepak Agarwal"},
    {text:"Good product variety and fast support. We always trust them.", name:"Pooja Singh"},
    {text:"Best trader for hardware and electrical items in the market.", name:"Manish Gupta"}
  ];

  return (
    <div>

      <header className="header">
        <div className="logo">Shyam Traders</div>
        <nav className={menu ? "nav open":"nav"}>
          <a href="#hero">Home</a>
          <a href="#about">About</a>
          <a href="#products">Products</a>
          <a href="#reviews">Reviews</a>
          <a href="#contact">Contact</a>
        </nav>
        <div className="hamburger" onClick={()=>setMenu(!menu)}>☰</div>
      </header>

      <section id="hero" className="hero">
        <div className="hero-text">
          <h1>Trusted Trading Partner for Quality Supplies</h1>
          <p>
          Shyam Traders has been serving industries and businesses with premium
          quality products, reliable supply chains, and competitive pricing.
          From hardware materials to industrial equipment, we deliver solutions
          that power businesses across the region.
          </p>
          <button>Explore Products</button>
        </div>
        <img src="https://images.unsplash.com/photo-1581092334651-ddf26d9a09d0" alt="hero"/>
      </section>

      <section id="about" className="section about">
        <h2>About Shyam Traders</h2>
        <p>
        Founded with the vision to provide reliable trading services, Shyam
        Traders has grown into a trusted supplier of industrial tools,
        construction materials, hardware products, and electrical components.
        Our commitment to quality, transparency, and customer satisfaction
        makes us a preferred partner for businesses and contractors.
        </p>

        <div className="features">
          <div className="feature">
            <h3>✔ Quality Products</h3>
            <p>We supply products sourced from trusted manufacturers.</p>
          </div>
          <div className="feature">
            <h3>✔ Competitive Pricing</h3>
            <p>Affordable pricing suitable for businesses of all sizes.</p>
          </div>
          <div className="feature">
            <h3>✔ Reliable Delivery</h3>
            <p>Timely supply ensuring uninterrupted business operations.</p>
          </div>
        </div>
      </section>

      <section id="products" className="section">
        <h2>Our Products</h2>
        <div className="product-grid">
          {products.map((p,i)=>(
            <div key={i} className="product">
              <img src={p.img} alt={p.name}/>
              <h3>{p.name}</h3>
            </div>
          ))}
        </div>
      </section>

      <section id="reviews" className="section reviews">
        <h2>Client Testimonials</h2>
        <div className="review-grid">
          {reviews.map((r,i)=>(
            <div key={i} className="review">
              <p>"{r.text}"</p>
              <span>- {r.name}</span>
            </div>
          ))}
        </div>
      </section>

      <section id="contact" className="section contact">
        <h2>Contact Us</h2>
        <div className="contact-container">

          <form className="contact-form">
            <input placeholder="Your Name"/>
            <input placeholder="Your Email"/>
            <textarea placeholder="Your Message"/>
            <button>Send Message</button>
          </form>

          <div className="contact-info">
            <h3>Business Details</h3>
            <p><strong>Email:</strong> admin@shyamtraders.shop</p>
            {/* <p><strong>Phone:</strong> +91 9876543210</p> */}
            <p><strong>Owner:</strong> GHANSHAM DAS PARWAL </p>
            <p>
            <strong>Address:</strong> P.NO.9,F.NO.102, SHANTI SANPDDHI, JAIPUR M Corp part, Babul Kirana, Dheraj colony, Murlipura Jaipur, Rajasthan 302039
            </p>
          </div>

        </div>
      </section>

      <footer className="footer">
        <p>© 2026 Shyam Traders. Trusted supplier of industrial and hardware products.</p>
      </footer>

    </div>
  );
}
